<article class="puja-section" style="display: none">
  <section class="puja-details mb-4">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 col-md-12 col-sm-12">
          <div class="puja-info">
            <div class="puja-title">
              <h2>{{ productDetails.productName }}</h2>
            </div>
            <div class="puja-description p-0">
              <p>{{ productDetails?.productShortDesc }}</p>
            </div>
          </div>
          <div class="col-lg-6 col-md-12 col-sm-12 desktvw">
            <div class="button">
              <div class="d-flex">
                <p class="price-icon">{{ gS.currencySign }}</p>
                <div class="price">{{ productDetails.productPrice }}</div>
              </div>
              <p class="book-btn">
                <a href="javascript:void(0);" *ngIf="userId" (click)="openCheckout(productDetails)">Book Now</a>
                <a href="javascript:void(0);" (click)="openLoginPopup('login')" *ngIf="!userId">Book Now</a>
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-12 col-sm-12 puja-img">
          <div id="carouselExampleAutoplaying" class="carousel slide" data-bs-ride="carousel">
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img src="{{ productDetails.productImage }}" alt="" class="img-fluid" />
              </div>
              <div class="carousel-item">
                <img src="{{ productDetails.productImage }}" alt="" class="img-fluid" />
              </div>
              <div class="carousel-item">
                <iframe width="470" height="305" src="https://www.youtube.com/watch?v=NJQU-HmyIvo"
                  frameborder="0"></iframe>
              </div>
            </div>
          </div>
          <!-- <div class="owl-carousel book-puja owl-theme">
                        <img src="{{productDetails.productImage}}" alt="" class="img-fluid">
                    </div> -->
        </div>
        <div class="col-lg-6 col-md-12 col-sm-12 mobvw d-none">
          <div class="button">
            <div class="d-flex">
              <p class="price-icon">{{ gS.currencySign }}</p>
              <a href="" class="price">{{ productDetails.productPrice }}</a>
            </div>
            <p class="book-btn">
              <a href="javascript:void(0);" *ngIf="userId" (click)="openCheckout(productDetails)">Book Now</a>
              <a href="javascript:void(0);" (click)="openLoginPopup('login')" *ngIf="!userId">Book Now</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="more_detail">
    <div class="container">
      <div class="row mb-4">
        <div class="col-lg-12 col-md-12 col-sm-12">
          <p class="p-0">
            <span>More Details about the
              {{ productDetails?.productTypeSlug }}:</span>
          </p>
          <div [innerHTML]="productDetails?.productLongDesc" class="long-desc">
            {{ productDetails?.productLongDesc }}
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="puja-benefits d-none">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12">
          <p class="p-0">
            <span class="more_detail">IMPORTANT:</span> will send the Puja
            Images to your registered email.
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12">
          <div class="d-flex align-items-center position-relative mb-3">
            <div class="more_detail">BENEFITS</div>
            <label class="line"></label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12">
          <div class="">
            <p>
              Performing Manokamna Siddhi Puja with devotion and sincerity can
              bring several benefits, including:
            </p>
            <ul class="list">
              <li>Attracts love and companionship into your life.</li>
              <li>
                Resolves conflicts and misunderstandings in relationships.
              </li>
              <li>Enhances marital harmony and strengthens bonds.</li>
              <li>Increases positivity and understanding between partners.</li>
              <li>
                Creates a favorable aura for finding a suitable life partner.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="puja-mantra d-none">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12">
          <div class="d-flex align-items-center position-relative mb-3">
            <div class="more_detail">MANTRA</div>
            <label class="line"></label>
          </div>
          <div class="">
            <p>
              The Mantra to be recited during the Manokamna Siddhi Puja for love
              is "ॐ क्लीं कामदेवाय नमः". This Mantra is believed to invoke the
              blessings of Kamadeva, the god of love and attraction, and can
              help manifest love in your life. The Mantra will be chanted
              alongside the Homam. This powerful Mantra is to be recited 1188
              (11 Mala*108) times.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="puja-includes d-none">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12">
          <div class="d-flex align-items-center position-relative mb-3">
            <div class="more_detail">PUJA INCLUDES</div>
            <label class="line"></label>
          </div>
          <div class="">
            <p>Mantra Chanting with Homam.</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="astro-guarantee d-none">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12">
          <div class="guar-sec">
            <div class="guar-title">
              <h3>AstroApp GUARANTEE</h3>
            </div>
            <div class="">
              <p>
                - We at AstroApp are genuinely concerned about the problems of
                our clients who put their valuable trust in us to perform the
                Puja on their behalf. Hence, we consider it our responsibility
                to ensure that the entire Puja follows the predefined Vedic
                ‘Vidhi Vidhan’, to attain the expected results.
              </p>
              <p>
                - To ensure the Puja is done correctly, Anytime Astro has formed
                a special and dedicated panel of professional Pandits headed and
                supervised by a senior Acharya Ji
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="astro-facts d-none">
    <div class="container">
      <div class="row d-none">
        <div class="col-lg-12 col-md-12 col-sm-12">
          <div class="d-flex align-items-center position-relative mb-3">
            <div class="more_detail">INTERESTING FACTS</div>
            <label class="line"></label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 col-md-12 col-sm-12">
          <!-- <ul class="list">
                        <li>The concept of Manokamna Siddhi Puja originated from ancient Hindu scriptures and is deeply
                            rooted in Vedic traditions.</li>
                   
                    </ul> -->
        </div>
        <div class="col-lg-6 col-md-12 col-sm-12">
          <div class="Consultation-btn d-flex align-items-center justify-content-center mt-5 float-xl-right float-left">
            <span class="Consultation-text">Get Consultation from Expert Advisors!</span>
            <a class="btn call-btn" routerLink="/talk-to-astrologer" target="_blank"><img
                src="../../assets/images/phone.svg" alt="call" width="25" height="22" />Chat/Call</a>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="how-works" *ngIf="productDetails?.productTypeSlug == 'puja'">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12">
          <h2 class="title"><span>How AstroApp Puj</span>a Works?</h2>
          <p class="content">
            AstroApp makes the experience of booking and performing onlne pujas
            extremely easy and available at your fingertips. You can easily go
            for a puja using our website or mobile app and following these
            simple steps:
          </p>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 mb-4">
          <div class="card puja">
            <div class="timeline">
              <div class="checkpoint">
                <p class="title">Select a Puja</p>
                <p class="text">
                  Choose from the list of pujas, that you want to go for.
                </p>
              </div>
              <div class="checkpoint">
                <p class="title">Fill your details</p>
                <p class="text">
                  Enter the basic details that purohit will require at the time
                  of performing puja.
                </p>
              </div>
              <div class="checkpoint">
                <p class="title">Confirm the puja booking</p>
                <p class="text">
                  Make the payment and get a confirmation of your puja booking.
                </p>
              </div>
              <div class="checkpoint">
                <p class="title">Puja Updates</p>
                <p class="text">
                  You will get updates for puja, scheduled date and time along
                  with a link where you will be able to join the puja virtually.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 mb-4 circle webView">
          <div class="image">
            <img src="/assets/image/indian-pandit.svg" alt="" />
          </div>
          <div class="icon">
            <div class="images">
              <div class="qualify1">
                <div class="imgBox1">
                  <img src="/assets/image/Vector11.svg" alt="" />
                </div>
                <div class="para">
                  <h2>Qualified & Proficient</h2>
                  <p>
                    We have tied up with expert to assure our clientele on
                    proficiency of pandits.
                  </p>
                </div>
              </div>
              <div class="qualify2">
                <div class="imgBox2">
                  <img src="/assets/image/Vector12.svg" alt="" />
                </div>
                <div class="para">
                  <h2>Language Specific</h2>
                  <p>
                    We cater to all major communities and languages in india.
                  </p>
                </div>
              </div>
              <div class="qualify3">
                <div class="imgBox3">
                  <img src="/assets/image/Vector13.svg" alt="" />
                </div>
                <div class="para">
                  <h2>Experienced & Knowledgable</h2>
                  <p>
                    All our purohits are well versed in Sanskrit and have good
                    prior experience of performing pujas.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="mobileView">
          <div class="mobileView-image">
            <img src="/assets/image/indian-pandit.svg" alt="" />
          </div>
          <div class="mobileView-timeline">
            <div class="mobileView-imgBox">
              <img src="/assets/image/Vector11.svg" alt="" />
            </div>
            <div class="mobileView-para">
              <p class="title">Qualified & Proficient</p>
              <p class="text">
                We have tied up with expert to assure our clientele on
                proficiency of pandits.
              </p>
            </div>
          </div>
          <div class="mobileView-timeline">
            <div class="mobileView-imgBox">
              <img src="/assets/image/Vector12.svg" alt="" />
            </div>
            <div class="mobileView-para">
              <p class="title">Language Specific</p>
              <p class="text">
                We cater to all major communities and languages in india.
              </p>
            </div>
          </div>
          <div class="mobileView-timeline">
            <div class="mobileView-imgBox">
              <img src="/assets/image/Vector13.svg" alt="" />
            </div>
            <div class="mobileView-para">
              <p class="title">Experienced & Knowledgable</p>
              <p class="text">
                All our purohits are well versed in Sanskrit and have good prior
                experience of performing pujas.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- <section class="more-pujas-sect mb-4">
        <div class="container">
            <h2 class="heading">Browse more {{productDetails?.productTypeSlug}}</h2>
            <app-home-puja-section [slugType]="slug" [heading]="" [viewAll]="false"></app-home-puja-section>
        </div>
    </section> -->
  <!-- <app-puja-common-pages></app-puja-common-pages> -->
</article>

<article class="new_detail_page container">
  <div class="upper_part">
    <div class="swiper_div">
      <div class="swiper thumbnailSwiperMain">
        <div class="swiper-wrapper">
          <div class="swiper-slide" *ngFor="let item of thumnailSwiperData">
            <img [src]="item" />
          </div>
        </div>
        <div class="swiper-button-prev custom-swiper-btn">
          <svg width="16" height="16" viewBox="0 0 24 24">
            <path d="M15 18l-6-6 6-6" stroke="white" stroke-width="2" fill="none" stroke-linecap="round" />
          </svg>
        </div>
        <div class="swiper-button-next custom-swiper-btn">
          <svg width="16" height="16" viewBox="0 0 24 24">
            <path d="M9 6l6 6-6 6" stroke="white" stroke-width="2" fill="none" stroke-linecap="round" />
          </svg>
        </div>
      </div>
      <div thumbsSlider="" class="swiper thumbnailSwiperThumb">
        <div class="swiper-wrapper">
          <div class="swiper-slide" *ngFor="let item of thumnailSwiperData">
            <img [src]="item" />
          </div>
        </div>
      </div>
    </div>
    <div class="product_detail_div">
      <p class="title">{{ productDetails?.productName }}</p>
      <div class="tag_div d-none">
        <!-- <div class="tags">
                    <p>Stamp Paper</p>
                </div> -->
        <div class="tags">
          <p>Download PDF</p>
        </div>
        <div class="tags">
          <p>Doorstep Delivery</p>
        </div>
      </div>

      <!-- <div class="rating_div">
                <ngx-stars [readonly]="true" [color]="'#ffa400'" [size]="1" [maxStars]="5"
                    [initialStars]="4"></ngx-stars>
                <p class="rating_num">5.0</p>
                <p class="rating_num">( 700 Ratings )</p>
            </div> -->
      <div class="price_div" *ngIf="isItrProduct">
        <p class="product_price">
          {{ gS.currencySign }} {{ productDetails?.productPrice }}
        </p>
      </div>
      <div class="price_div" *ngIf="!isItrProduct">
        <p class="product_price">
          {{ gS.currencySign }} {{ productDetails?.productPrice }}
        </p>
        <!-- <p class="discount_price">Rs. 700 </p>
                <p class="discount_text">40% Discount on Rent Agreement</p> -->
      </div>

      <div class="download_text_btn d-none">
        <p>Download PDF Instantly | Hard Copy Dispatched in 24 Hrs.</p>
      </div>

      <div class="btns">
        <button class="book_now" *ngIf="userId" (click)="openCheckout(productDetails)">
          Book Now
        </button>
        <button class="book_now" (click)="openLoginPopup('login')" *ngIf="!userId">
          Book Now
        </button>
        <a target="_blank"
          href="https://api.whatsapp.com/send?phone=918287336859&text=Hello!%20👋%20Welcome%20to%20LegalStack!%20We’re%20happy%20to%20have%20you%20here.%20Please%20share%20your%20query%20or%20requirement%20below%20—%20our%20team%20will%20get%20back%20to%20you%20shortly.%20😊">
          <button class="book_now contactsupport"> <svg _ngcontent-ng-c853840360="" xmlns="http://www.w3.org/2000/svg"
              width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path _ngcontent-ng-c853840360="" fill-rule="evenodd" clip-rule="evenodd"
                d="M14.921 0.255076C11.7929 -0.0652505 8.64846 -0.0839072 5.51787 0.199285L5.29377 0.220206C3.85439 0.350686 2.50918 1.12951 1.52754 2.40072C0.545901 3.67193 0.000298841 5.34166 0 7.07553V18.9548C0.000132966 19.1357 0.039293 19.3134 0.113659 19.4706C0.188024 19.6279 0.295055 19.7593 0.424308 19.852C0.55356 19.9447 0.700618 19.9956 0.851131 19.9997C1.00164 20.0038 1.15047 19.961 1.28309 19.8754L5.82326 16.945C6.03493 16.8083 6.27153 16.7369 6.51184 16.7371H16.9345C18.2489 16.7371 19.3753 15.6074 19.611 14.055C20.0894 10.907 20.1265 7.68505 19.7225 4.5217L19.604 3.58859C19.4987 2.76423 19.1658 2.00632 18.6587 1.43665C18.1515 0.866975 17.4997 0.518619 16.8079 0.447555L14.921 0.255076ZM5.65025 2.28587C8.68801 2.01009 11.7393 2.02782 14.7747 2.33887L16.6605 2.53275C17.2828 2.59691 17.7891 3.16458 17.8832 3.9066L18.0028 4.83831C18.376 7.77207 18.3407 10.76 17.8983 13.6798C17.8579 13.9509 17.7392 14.1963 17.5632 14.3728C17.3871 14.5493 17.165 14.6457 16.9356 14.645H6.51184C5.98416 14.6451 5.46473 14.8023 4.99999 15.1025L1.74175 17.2058V7.07553C1.74181 5.8693 2.12121 4.70761 2.80398 3.82308C3.48675 2.93856 4.42248 2.39648 5.42382 2.3054L5.65025 2.28587Z"
                fill="#64748B"></path>
            </svg>
            Contact Support
          </button></a>

        <button class="view_sample d-none">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="22" viewBox="0 0 18 22" fill="none">
            <path
              d="M5 10H13M5 13H13M5 16H9.17M1 15V7C1 4.172 1 2.757 1.879 1.879C2.757 1 4.172 1 7 1H11.172C11.58 1 11.785 1 11.969 1.076C12.152 1.152 12.297 1.296 12.586 1.586L16.414 5.414C16.704 5.704 16.848 5.848 16.924 6.032C17 6.215 17 6.42 17 6.828V15C17 17.828 17 19.243 16.121 20.121C15.243 21 13.828 21 11 21H7C4.172 21 2.757 21 1.879 20.121C1 19.243 1 17.828 1 15Z"
              stroke="#64748B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          View Sample
        </button>
      </div>

      <ul class="trust_strip">
        <li><i class="fa-solid fa-shield-halved"></i> 100% Online Process</li>
        <li><i class="fa-solid fa-user-check"></i> Verified CAs &amp; Lawyers</li>
        <li><i class="fa-solid fa-tag"></i> Transparent Pricing</li>
        <li><i class="fa-solid fa-clock"></i> On-time Filing</li>
      </ul>

      <div class="need_assitance">
        <p class="need_text">Need Assistance</p>
        <button (click)="contactUs()">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M14.921 0.255076C11.7929 -0.0652505 8.64846 -0.0839072 5.51787 0.199285L5.29377 0.220206C3.85439 0.350686 2.50918 1.12951 1.52754 2.40072C0.545901 3.67193 0.000298841 5.34166 0 7.07553V18.9548C0.000132966 19.1357 0.039293 19.3134 0.113659 19.4706C0.188024 19.6279 0.295055 19.7593 0.424308 19.852C0.55356 19.9447 0.700618 19.9956 0.851131 19.9997C1.00164 20.0038 1.15047 19.961 1.28309 19.8754L5.82326 16.945C6.03493 16.8083 6.27153 16.7369 6.51184 16.7371H16.9345C18.2489 16.7371 19.3753 15.6074 19.611 14.055C20.0894 10.907 20.1265 7.68505 19.7225 4.5217L19.604 3.58859C19.4987 2.76423 19.1658 2.00632 18.6587 1.43665C18.1515 0.866975 17.4997 0.518619 16.8079 0.447555L14.921 0.255076ZM5.65025 2.28587C8.68801 2.01009 11.7393 2.02782 14.7747 2.33887L16.6605 2.53275C17.2828 2.59691 17.7891 3.16458 17.8832 3.9066L18.0028 4.83831C18.376 7.77207 18.3407 10.76 17.8983 13.6798C17.8579 13.9509 17.7392 14.1963 17.5632 14.3728C17.3871 14.5493 17.165 14.6457 16.9356 14.645H6.51184C5.98416 14.6451 5.46473 14.8023 4.99999 15.1025L1.74175 17.2058V7.07553C1.74181 5.8693 2.12121 4.70761 2.80398 3.82308C3.48675 2.93856 4.42248 2.39648 5.42382 2.3054L5.65025 2.28587Z"
              fill="#64748B" />
          </svg>
          Contact Support
        </button>
      </div>

      <div class="accordion" id="product_descp_accor">
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingOne">
            <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne"
              aria-expanded="true" aria-controls="collapseOne">
              More About {{ productDetails?.productName }}
            </button>
          </h2>
          <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne"
            data-bs-parent="#product_descp_accor">
            <div class="accordion-body">
              <p [innerHTML]="productDetails?.productLongDesc"></p>
            </div>
          </div>
        </div>
        <div class="accordion-item" *ngFor="let general of productDetails?.generalDetails; let i = index">
          <h2 class="accordion-header" [id]="'heading-general' + i">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
              [attr.data-bs-target]="'#collapse-general' + i" aria-expanded="false"
              [attr.aria-controls]="'collapse-general' + i">
              {{ general?.title }}
            </button>
          </h2>
          <div [id]="'collapse-general' + i" class="accordion-collapse collapse"
            [attr.aria-labelledby]="'heading-general' + i" data-bs-parent="#product_descp_accor">
            <div class="accordion-body">
              <p [innerHTML]="general?.description"></p>
            </div>
          </div>
        </div>

        <div class="accordion-item" *ngIf="
            productDetails?.faqDetails && productDetails?.faqDetails?.length > 0
          ">
          <h2 class="accordion-header" id="headingFour">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
              data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
              Frequently Asked Questions
            </button>
          </h2>
          <div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="headingFour"
            data-bs-parent="#product_descp_accor">
            <div class="accordion-body">
              <div class="accordion" id="nestedAccordion">
                <div class="accordion-item" *ngFor="let faq of productDetails?.faqDetails; let j = index">
                  <h2 class="accordion-header" [id]="'nestedHeading' + j">
                    <button class="accordion-button accordion-button_2 collapsed" type="button"
                      data-bs-toggle="collapse" [attr.data-bs-target]="'#nestedCollapse' + j" aria-expanded="false"
                      [attr.aria-controls]="'nestedCollapse' + j">
                      {{ faq.title }}
                    </button>
                  </h2>
                  <div [id]="'nestedCollapse' + j" class="accordion-collapse collapse"
                    [attr.aria-labelledby]="'nestedHeading' + j" data-bs-parent="#nestedAccordion">
                    <div class="accordion-body">
                      <p [innerHTML]="faq.description"></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="book_step_div">
    <div class="left_part">
      <p class="title">How to Book {{ productDetails?.productName }}?</p>
      <div class="steps_div">
        <div class="steps">
          <div class="step_count">
            <p class="count_text">1</p>
            <div class="divider"></div>
          </div>
          <p class="step_text">Login using Mobile No. and OTP</p>
        </div>
        <div class="steps">
          <div class="step_count">
            <p class="count_text">2</p>
            <div class="divider"></div>
          </div>
          <p class="step_text">Enter all details required in the intake form</p>
        </div>
        <div class="steps">
          <div class="step_count">
            <p class="count_text">3</p>
          </div>
          <p class="step_text">Verify Details and Make Payment.</p>
        </div>
      </div>
    </div>

    <div class="right_part">
      <img [src]="this.productDetails?.productImage" alt="productImage" class="book_img" />
      <div class="youtub_img">
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M14 28C17.713 28 21.274 26.525 23.8995 23.8995C26.525 21.274 28 17.713 28 14C28 10.287 26.525 6.72601 23.8995 4.10051C21.274 1.475 17.713 0 14 0C10.287 0 6.72601 1.475 4.10051 4.10051C1.475 6.72601 0 10.287 0 14C0 17.713 1.475 21.274 4.10051 23.8995C6.72601 26.525 10.287 28 14 28ZM13.2213 9.044C12.9577 8.86816 12.6514 8.76717 12.3349 8.7518C12.0185 8.73643 11.7038 8.80725 11.4244 8.95672C11.1451 9.10619 10.9115 9.32869 10.7487 9.60048C10.5859 9.87228 10.5 10.1832 10.5 10.5V17.5C10.5 17.8168 10.5859 18.1277 10.7487 18.3995C10.9115 18.6713 11.1451 18.8938 11.4244 19.0433C11.7038 19.1927 12.0185 19.2636 12.3349 19.2482C12.6514 19.2328 12.9577 19.1318 13.2213 18.956L18.4713 15.456C18.7109 15.2962 18.9074 15.0797 19.0434 14.8257C19.1793 14.5717 19.2504 14.2881 19.2504 14C19.2504 13.7119 19.1793 13.4283 19.0434 13.1743C18.9074 12.9203 18.7109 12.7038 18.4713 12.544L13.2213 9.044Z"
            fill="#D23306" />
        </svg>
      </div>
    </div>
  </div>

  <div class="accordion accordion_hide" id="product_descp_accor">
    <div class="accordion-item">
      <h2 class="accordion-header" id="headingOne">
        <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne"
          aria-expanded="true" aria-controls="collapseOne">
          More About {{ productDetails?.productName }}
        </button>
      </h2>
      <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne"
        data-bs-parent="#product_descp_accor">
        <div class="accordion-body">
          <p [innerHTML]="productDetails?.productLongDesc"></p>
        </div>
      </div>
    </div>
    <div class="accordion-item" *ngFor="let general of productDetails?.generalDetails; let i = index">
      <h2 class="accordion-header" [id]="'heading-general' + i">
        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
          [attr.data-bs-target]="'#collapse-general' + i" aria-expanded="false"
          [attr.aria-controls]="'collapse-general' + i">
          {{ general?.title }}
        </button>
      </h2>
      <div [id]="'collapse-general' + i" class="accordion-collapse collapse"
        [attr.aria-labelledby]="'heading-general' + i" data-bs-parent="#product_descp_accor">
        <div class="accordion-body">
          <p [innerHTML]="general?.description"></p>
        </div>
      </div>
    </div>

    <div class="accordion-item" *ngIf="
        productDetails?.faqDetails && productDetails?.faqDetails?.length > 0
      ">
      <h2 class="accordion-header" id="headingFour">
        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
          data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
          Frequently Asked Questions
        </button>
      </h2>
      <div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="headingFour"
        data-bs-parent="#product_descp_accor">
        <div class="accordion-body">
          <div class="accordion" id="nestedAccordion">
            <div class="accordion-item" *ngFor="let faq of productDetails?.faqDetails; let j = index">
              <h2 class="accordion-header" [id]="'nestedHeading' + j">
                <button class="accordion-button accordion-button_2 collapsed" type="button" data-bs-toggle="collapse"
                  [attr.data-bs-target]="'#nestedCollapse' + j" aria-expanded="false"
                  [attr.aria-controls]="'nestedCollapse' + j">
                  {{ faq.title }}
                </button>
              </h2>
              <div [id]="'nestedCollapse' + j" class="accordion-collapse collapse"
                [attr.aria-labelledby]="'nestedHeading' + j" data-bs-parent="#nestedAccordion">
                <div class="accordion-body">
                  <p [innerHTML]="faq.description"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-customer-says></app-customer-says>

  <!-- <app-more-services></app-more-services> -->
  <div id="more_services" class="more_services swiper-wrapper-hidden" *ngIf="productData.length">
    <div class="ms_header">
      <div class="ms_heading">
        <p class="title">More Services by LegalStack</p>
        <p class="subtitle">Explore other offerings tailored to grow your business</p>
      </div>
      <div class="ms_nav">
        <button type="button" class="swiper-button-prev custom-swiper-btn" aria-label="Previous services">
          <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 6 10" fill="none">
            <path
              d="M0.509058 5.0045C0.508334 5.06345 0.520049 5.12191 0.543448 5.17611C0.566848 5.2303 0.601416 5.27904 0.644928 5.31918L4.72101 9.36513C4.90217 9.54496 5.18297 9.54496 5.36413 9.36513C5.54529 9.18531 5.54529 8.90659 5.36413 8.72677L1.60507 4.9955L5.35507 1.27323C5.53623 1.09341 5.53623 0.814685 5.35507 0.634865C5.17391 0.455045 4.89312 0.455045 4.71196 0.634865L0.63587 4.68082C0.54529 4.77073 0.5 4.88761 0.5 4.9955L0.509058 5.0045Z"
              fill="currentColor" />
          </svg>
        </button>
        <button type="button" class="swiper-button-next custom-swiper-btn" aria-label="Next services">
          <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 6 10" fill="none">
            <path
              d="M5.49094 5.0045C5.49167 5.06345 5.47995 5.12191 5.45655 5.17611C5.43315 5.2303 5.39858 5.27904 5.35507 5.31918L1.27899 9.36513C1.09783 9.54496 0.817029 9.54496 0.63587 9.36513C0.45471 9.18531 0.45471 8.90659 0.63587 8.72677L4.39493 4.9955L0.644928 1.27323C0.463768 1.09341 0.463768 0.814685 0.644928 0.634865C0.826087 0.455045 1.10688 0.455045 1.28804 0.634865L5.36413 4.68082C5.45471 4.77073 5.5 4.88761 5.5 4.9955L5.49094 5.0045Z"
              fill="currentColor" />
          </svg>
        </button>
      </div>
    </div>

    <div class="swiper moreServiceSwiper">
      <div class="swiper-wrapper">
        <div class="swiper-slide" *ngFor="let item of productData">
          <div class="services_card" (click)="navigateToProduct(item)" role="button" tabindex="0"
            (keydown.enter)="navigateToProduct(item)">
            <div class="img_wrap">
              <img class="product_img" [src]="item?.productImage" [alt]="item?.productName" loading="lazy" />
            </div>
            <div class="product_detail">
              <p class="product_title">{{ item?.productName }}</p>
              <button type="button" class="view_btn"
                (click)="$event.stopPropagation(); navigateToProduct(item)">
                <span>View Details</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 6 10" fill="none">
                  <path
                    d="M5.49094 5.0045C5.49167 5.06345 5.47995 5.12191 5.45655 5.17611C5.43315 5.2303 5.39858 5.27904 5.35507 5.31918L1.27899 9.36513C1.09783 9.54496 0.817029 9.54496 0.63587 9.36513C0.45471 9.18531 0.45471 8.90659 0.63587 8.72677L4.39493 4.9955L0.644928 1.27323C0.463768 1.09341 0.463768 0.814685 0.644928 0.634865C0.826087 0.455045 1.10688 0.455045 1.28804 0.634865L5.36413 4.68082C5.45471 4.77073 5.5 4.88761 5.5 4.9955L5.49094 5.0045Z"
                    fill="currentColor" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-service-plan></app-service-plan>
  <app-tds-solution></app-tds-solution>
</article>

<app-login *ngIf="isLoginPopup" (close)="closeLoginPopup()" [loginPopuptype]="loginPopuptype"></app-login>


<div class="checkout-overlay" *ngIf="openCheckoutPage" (click)="onOverlayClick()">
  <app-product-checkout class="checkout-canvas" (click)="$event.stopPropagation()" [productDetails]="productDetails" (click)="$event.stopPropagation()"
    (close)="closePopup($event)" (success)="eventCheckoutSuccess($event)">
  </app-product-checkout>
</div>
<!-- <app-product-checkout *ngIf="openCheckoutPage" [productDetails]="productDetails" (close)="closePopup($event)" (success)="eventCheckoutSuccess($event)"></app-product-checkout> -->

<app-product-order-payment *ngIf="openPaymentPage" (close)="closePopup($event)"
  (paymentSuccess)="paymentSuccess($event)"></app-product-order-payment>

<app-order-success *ngIf="isOrderSuccess" (close)="closeOrderSuccessPopup($event)"></app-order-success>